<template>
  <div>
    {{ info }}
    <van-field
      v-model="temp.学校名称"
      label="学校名称"
      placeholder="学校名称"
      :rules="[{ required: true, message: '姓名不能为空' }]"
    />
    <van-field
      v-model="temp.专业名称"
      label="专业名称"
      placeholder="专业名称"
      :rules="[{ required: true, message: '专业名称' }]"
    />
    <van-field
      v-model="temp.学历"
      label="学历"
      placeholder="学历"
      :rules="[{ required: true, message: '学历' }]"
    />
    <van-field
      v-model="temp.学习形式"
      label="学习形式"
      placeholder="学习形式"
      :rules="[{ required: true, message: '学习形式' }]"
    />

    <van-field
      v-model="temp.入学时间"
      readonly
      clickable
      label="入学时间"
      placeholder="选择入学时间"
      @click="ShowDatePup('入学时间')"
      :rules="[{ required: true, message: '选择入学时间' }]"
    />

    <van-field
      v-model="temp.毕业时间"
      readonly
      clickable
      label="毕业时间"
      placeholder="选择毕业时间"
      @click="ShowDatePup('毕业时间')"
      :rules="[{ required: true, message: '选择毕业时间' }]"
    />
    <div style="margin: 16px">
      <van-row>
        <van-col span="8"
          ><van-button round block @click.prevent="$emit('handlerStep', -1)"
            >上一步</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button round block @click.prevent="addData()"
            >保存并新增</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button round block @click.prevent="$emit('handlerStep', 1)"
            >下一步</van-button
          >
        </van-col>
      </van-row>
    </div>

    <!-- 出生日期选择弹窗 -->
    <van-popup v-model="showDatePup" position="bottom">
      <van-datetime-picker
         type="date" format="yyyy-MM-dd"  value-format="yyyy-MM-dd" 
        title="日期"
        :min-date="minDate"
        @cancel="showDatePup = false"
        @confirm="onDate"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "baseinfo",
  props: ["info"],
  data() {
    return {
      
      dateFieldname: "",
      temp: {},
      showDatePup: false,
      minDate: new Date(1960, 0, 1),
    };
  },
  methods: {
    ShowDatePup(dateFieldname) {
      this.showDatePup = true;
      this.dateFieldname = dateFieldname;
    },
    addData() {
      console.log(this.info);
      this.info.push(this.temp);
      this.temp = {};
    },
    onDate(value) {
      console.log("www");
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();
      let v = year + "年" + month + "月" + day + "日";
      this.$set(this.temp, this.dateFieldname, v);
      this.showDatePup = false;
    },
  },
};
</script>
<style scoped>
.prop {
  font-size: 12px;

  background-color: chocolate;
  color: cadetblue;
}
</style>
